import { useState } from "react";
import httpService from "../services/httpService";
import posthog from 'posthog-js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { Link } from "react-router-dom";

import { FaArrowRightFromBracket, FaSpinner, FaRegCircleCheck } from "react-icons/fa6";
import AnimatedImage from "../components/AnimatedImage";

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            await httpService.post("password/forgot", { email });
            posthog.capture('password_reset_requested');
            setSubmitted(true);
        } catch (err) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <Card style={{ overflow: 'hidden' }}>
                        <Row className="g-0">
                            <Col>
                                <div className='p-3'>
                                    <div className={'position-absolute'}>
                                        <Link to="/login"><FaArrowRightFromBracket /></Link>
                                    </div>
                                    <div className={'text-center'}>
                                        <AnimatedImage
                                            src="/img/podsy-logo-w-200.png"
                                            fluid
                                            alt="Podsy Logo"
                                            loopMs={3000}
                                            aberration={true}
                                            className=""
                                        />
                                    </div>

                                    {submitted ? (
                                        <div className="text-center py-3">
                                            <FaRegCircleCheck size={40} className="mb-3 text-success" />
                                            <h5>Check your inbox</h5>
                                            <p className="text-muted">
                                                If that email is registered you'll receive a reset link shortly.
                                            </p>
                                            <Link to="/login" className="btn btn-light w-100 mt-2">Back to login</Link>
                                        </div>
                                    ) : (
                                        <>
                                            <h5 className="text-center mb-3">Forgot your password?</h5>
                                            <p className="text-muted text-center small mb-3">
                                                Enter your email and we'll send you a reset link.
                                            </p>
                                            <Form onSubmit={handleSubmit}>
                                                <Form.Group className="mb-4" controlId="Email">
                                                    <Form.Label>Email address</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        disabled={loading}
                                                        placeholder="Enter email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        isInvalid={!!error}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {error}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Button disabled={loading} className="w-100 mb-3" variant="light" type="submit">
                                                    {loading ? <FaSpinner className={"loading_spinner"} /> : 'Send reset link'}
                                                </Button>
                                            </Form>
                                            <Row className={'mt-2 text-center'}>
                                                <Col>
                                                    <Link to="/login" className="small">Back to login</Link>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgotPassword;
